import React from "react";

// components
import StudentList from "./list";
import SideBar from "./sideSection";
import Loader from "./loader";

// mui
import { Grid, makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
const useStyles = makeStyles(() => ({
    studentList: {
        paddingLeft: `16px!important`,
        paddingBottom: `16px!important`,
        maxHeight: "890px",
        overflowY: "scroll",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
            width: 6,
            height: 6,
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            borderRadius: 5,
        },
    },
}));

export default function StudentTab() {
    const classes = useStyles();
    const loadingStudentList = useSelector((state) => state.studentDetails.loadingList);
    const [activeStudent, setActiveStudent] = React.useState(null);

    const handleSetActiveStudent = (data) => {
        setActiveStudent(data);
    };

    if (loadingStudentList) {
        return <Loader />;
    }

    return (
        <Grid container spacing={2}>
            <Grid item sm={12} md={7} lg={8} className={classes.studentList}>
                <StudentList handleSetActiveStudent={handleSetActiveStudent} />
            </Grid>
            <Grid item sm={12} md={5} lg={4}>
                <SideBar studentData={activeStudent} />
            </Grid>
        </Grid>
    );
}
